export default __webpack_public_path__ + "static/media/ctara-logo.d585ba62.png";